<template>
  <div class="container-fluid mt-3">
    <h2>Skript: {{ script.id }}</h2>
    <div role="toolbar" class="btn-toolbar justify-content-between">
      <button @click="save()" class="btn btn-primary"><font-awesome-icon icon="save"/>&nbsp;Speichern</button>
      <div class="form-inline ml-3">
        <label>Skript-Name:</label>
        <input type="text" class="form-control ml-2" v-model="script.id"/>
      </div>
      <div class="form-check">
        <input type="checkbox" class="form-check-input" id="useBlocks" v-model="script.useBlocks"/>
        <label for="useBlocks">Blocks benutzen</label>
      </div>
      <button @click="importBlocks" class="btn btn-secondary">Blocks 2 Skript</button>
      <div class="input-group">
        <input placeholder="Variablenname = param" v-model="paramdata" type="text" class="form-control">
        <div class="input-group-append">
          <button @click="execScript" class="btn btn-secondary">Ausführen</button>
        </div>
      </div>
    </div>
    <hr/>
    <div class="row">
      <div class="col-md-auto" style="min-width:220px;">
        <h4>Skript Kategorien</h4>
        <CTreeView ref="cattree" @selectnode="updateCategory" treeid="scriptrules"/>
      </div>
      <div class="col-9">
        <b-tabs v-model="tabIndex">
          <b-tab title="Skript">
            <div class="container-fluid mt-3" style="height:600px;">
              <AceEditor ref="editor" editorId="scriptEditor" lang="javascript" :content="script.script"/>
            </div>
          </b-tab>
          <b-tab title="Blocks">
            <div class="container-fluid mt-3" style="height:600px;">
              <div id="blocklyDiv" style="height: 600px; width: 100%;"></div>
            </div>
          </b-tab>
          <b-tab title="Parameter">
            <div class="row">
              <div class="col p-1">
                <h4>Eingabeparameter</h4>
                <button @click="addInputParam" class="btn btn-primary"><font-awesome-icon icon="plus"/></button>
                <ul class="list-group mt-3">
                  <li v-for="(val,key) in script.input" :key="key" class="list-group-item">
                    <b>{{ val.name }}</b> ({{ val.dataType }}) - {{ val.hint }}
                    <div class="btn-group float-right">
                      <button @click="editInputParam(val)" class="btn btn-secondary" name="editInput"><font-awesome-icon icon="edit"/></button>
                      <button @click="removeInputParam(val.name)" class="btn btn-danger" name="delfield"><font-awesome-icon icon="trash"/></button>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="col p-1">
                <h4>Ausgabe</h4>
                <button @click="addOutputParam" class="btn btn-primary"><font-awesome-icon icon="plus"/></button>
                <ul class="list-group mt-3">
                <li v-for="(val,key) in script.output" :key="key" class="list-group-item">
                  <b>{{ val.name }}</b> ({{ val.dataType }}) - {{ val.hint }}
                  <div class="btn-group float-right">
                    <button @click="editOutputParam(val)" class="btn btn-secondary" name="editInput"><font-awesome-icon icon="edit"/></button>
                    <button @click="removeOutputParam(val.name)" class="btn btn-danger" name="delfield"><font-awesome-icon icon="trash"/></button>
                  </div>
                </li>
                </ul>
              </div>
            </div>
          </b-tab>
          <b-tab title="Planung">
            <CronExprBuilder ref="cron" class="mt-3"/>
          </b-tab>
          <b-tab title="Hilfe">
            <iframe style="width:100%;height:500px;border: none;" src="/trendshop.proxy.web/help/scriptmodules/index.html">
            </iframe>
          </b-tab>
        </b-tabs>
      </div>
    </div>
    <b-modal id="inputParam" @ok="saveInputParam">
      <h5>Eingabeparameter</h5>
      <div class="form-group">
        <label>Name</label>
        <input type="text" class="form-control" v-model="inputEdit.name"/>
      </div>
      <div class="form-group">
        <label>Datentyp</label>
        <select class="form-control" v-model="inputEdit.dataType">
          <option value="string">String</option>
          <option value="integer">Integer</option>
          <option value="long">Long</option>
          <option value="double">Double</option>
          <option value="timestamp">Zeitstempel</option>
          <option value="boolean">Boolean</option>
          <option value="jsonobj">JSON Object</option>
          <option value="jsonarray">JSON Array</option>
        </select>
      </div>
      <div class="form-group">
        <label>Default Wert</label>
        <input type="text" class="form-control" v-model="inputEdit.defVal"/>
      </div>
      <div class="form-group">
        <label>Hinweis Text</label>
        <input type="text" class="form-control" v-model="inputEdit.hint"/>
      </div>
    </b-modal>
    <b-modal id="outputParam" @ok="saveOutputParam">
      <h5>Ausgabeparameter</h5>
      <div class="form-group">
        <label>Name</label>
        <input type="text" class="form-control" v-model="outputEdit.name"/>
      </div>
      <div class="form-group">
        <label>Datentyp</label>
        <select class="form-control" v-model="outputEdit.dataType">
          <option value="string">String</option>
          <option value="integer">Integer</option>
          <option value="long">Long</option>
          <option value="double">Double</option>
          <option value="timestamp">Zeitstempel</option>
          <option value="boolean">Boolean</option>
          <option value="jsonobj">JSON Object</option>
          <option value="jsonarray">JSON Array</option>
        </select>
      </div>
      <div class="form-group">
        <label>Default Wert</label>
        <input type="text" class="form-control" v-model="outputEdit.defVal"/>
      </div>
      <div class="form-group">
        <label>Hinweis Text</label>
        <input type="text" class="form-control" v-model="outputEdit.hint"/>
      </div>
    </b-modal>
    <xml id="toolbox" style="display: none">
      <category name="Variablen" colour="#a55b80" custom="VARIABLE"></category>
      <sep></sep>
      <category name="Funktionen" colour="#995ba5" custom="PROCEDURE"></category>
      <sep></sep>
      <category name="System" colour="#b77c90">
        <block type="sys_exec">
        </block>
        <block type="sys_log">
        </block>
        <block type="sys_sleep">
        </block>
        <block type="sys_print">
        </block>
      </category>
      <sep></sep>
      <category name="Network" colour="#a56b90">
        <block type="web_request">
        </block>
        <block type="email_send">
        </block>
      </category>
      <sep></sep>
      <category name="Artikel" colour="#33cc00">
        <block type="article_load">
        </block>
        <block type="article_search">
        </block>
      </category>
      <sep></sep>
      <category name="Kunden" colour="#cc88a0">
        <block type="customer_load">
        </block>
        <block type="customer_search">
        </block>
        <block type="customer_contact_load">
        </block>
      </category>
      <sep></sep>
      <category name="Logik" colour="#5b80a5">
        <block type="controls_if"></block>
        <block type="logic_compare">
          <field name="OP">EQ</field>
        </block>
        <block type="logic_operation">
          <field name="OP">AND</field>
        </block>
        <block type="logic_negate"></block>
        <block type="logic_boolean">
          <field name="BOOL">TRUE</field>
        </block>
        <block type="logic_null"></block>
        <block type="logic_ternary"></block>
      </category>
      <sep></sep>
      <category name="Listen" colour="#745ba5">
        <block type="lists_create_with">
          <mutation items="0"></mutation>
        </block>
        <block type="lists_create_with">
          <mutation items="3"></mutation>
        </block>
        <block type="lists_repeat">
          <value name="NUM">
            <shadow type="math_number">
              <field name="NUM">5</field>
            </shadow>
          </value>
        </block>
        <block type="lists_length"></block>
        <block type="lists_isEmpty"></block>
        <block type="lists_indexOf">
          <field name="END">FIRST</field>
          <value name="VALUE">
            <block type="variables_get">
              <field name="VAR" id="QNlg||V5q7xpcDlI=bqm">list</field>
            </block>
          </value>
        </block>
        <block type="lists_getIndex">
          <mutation statement="false" at="true"></mutation>
          <field name="MODE">GET</field>
          <field name="WHERE">FROM_START</field>
          <value name="VALUE">
            <block type="variables_get">
              <field name="VAR" id="QNlg||V5q7xpcDlI=bqm">list</field>
            </block>
          </value>
        </block>
        <block type="lists_setIndex">
          <mutation at="true"></mutation>
          <field name="MODE">SET</field>
          <field name="WHERE">FROM_START</field>
          <value name="LIST">
            <block type="variables_get">
              <field name="VAR" id="QNlg||V5q7xpcDlI=bqm">list</field>
            </block>
          </value>
        </block>
        <block type="lists_getSublist">
          <mutation at1="true" at2="true"></mutation>
          <field name="WHERE1">FROM_START</field>
          <field name="WHERE2">FROM_START</field>
          <value name="LIST">
            <block type="variables_get">
              <field name="VAR" id="QNlg||V5q7xpcDlI=bqm">list</field>
            </block>
          </value>
        </block>
        <block type="lists_split">
          <mutation mode="SPLIT"></mutation>
          <field name="MODE">SPLIT</field>
          <value name="DELIM">
            <shadow type="text">
              <field name="TEXT">,</field>
            </shadow>
          </value>
        </block>
        <block type="lists_sort">
          <field name="TYPE">NUMERIC</field>
          <field name="DIRECTION">1</field>
        </block>
      </category>
      <sep></sep>
      <category name="Schleifen" colour="#5ba55b">
        <block type="controls_repeat_ext">
          <value name="TIMES">
            <shadow type="math_number">
              <field name="NUM">10</field>
            </shadow>
          </value>
        </block>
        <block type="controls_whileUntil">
          <field name="MODE">WHILE</field>
        </block>
        <block type="controls_for">
          <field name="VAR" id="!C6duT[p==`NepKLD)`_">i</field>
          <value name="FROM">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
          <value name="TO">
            <shadow type="math_number">
              <field name="NUM">10</field>
            </shadow>
          </value>
          <value name="BY">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
        </block>
        <block type="controls_forEach">
          <field name="VAR" id="q%r$MR:0glWH)ap.0YYG">j</field>
        </block>
        <block type="controls_flow_statements">
          <field name="FLOW">BREAK</field>
        </block>
      </category>
      <sep></sep>
      <category name="Text" colour="#5ba58c">
        <block type="text">
          <field name="TEXT"></field>
        </block>
        <block type="text_join">
          <mutation items="2"></mutation>
        </block>
        <block type="text_append">
          <field name="VAR" id="w?Hv8Ldr1gsVeFS/{4xq">item</field>
          <value name="TEXT">
            <shadow type="text">
              <field name="TEXT"></field>
            </shadow>
          </value>
        </block>
        <block type="text_length">
          <value name="VALUE">
            <shadow type="text">
              <field name="TEXT">abc</field>
            </shadow>
          </value>
        </block>
        <block type="text_isEmpty">
          <value name="VALUE">
            <shadow type="text">
              <field name="TEXT"></field>
            </shadow>
          </value>
        </block>
        <block type="text_indexOf">
          <field name="END">FIRST</field>
          <value name="VALUE">
            <block type="variables_get">
              <field name="VAR" id="[TCCP,.x3s_hLe+MIZSn">text</field>
            </block>
          </value>
          <value name="FIND">
            <shadow type="text">
              <field name="TEXT">abc</field>
            </shadow>
          </value>
        </block>
        <block type="text_charAt">
          <mutation at="true"></mutation>
          <field name="WHERE">FROM_START</field>
          <value name="VALUE">
            <block type="variables_get">
              <field name="VAR" id="[TCCP,.x3s_hLe+MIZSn">text</field>
            </block>
          </value>
        </block>
        <block type="text_getSubstring">
          <mutation at1="true" at2="true"></mutation>
          <field name="WHERE1">FROM_START</field>
          <field name="WHERE2">FROM_START</field>
          <value name="STRING">
            <block type="variables_get">
              <field name="VAR" id="[TCCP,.x3s_hLe+MIZSn">text</field>
            </block>
          </value>
        </block>
        <block type="text_changeCase">
          <field name="CASE">UPPERCASE</field>
          <value name="TEXT">
            <shadow type="text">
              <field name="TEXT">abc</field>
            </shadow>
          </value>
        </block>
        <block type="text_trim">
          <field name="MODE">BOTH</field>
          <value name="TEXT">
            <shadow type="text">
              <field name="TEXT">abc</field>
            </shadow>
          </value>
        </block>
        <block type="text_sysprint">
          <value name="value">
            <shadow type="text">
              <field name="TEXT">abc</field>
            </shadow>
          </value>
        </block>
        <block type="text_prompt_ext">
          <mutation type="TEXT"></mutation>
          <field name="TYPE">TEXT</field>
          <value name="TEXT">
            <shadow type="text">
              <field name="TEXT">abc</field>
            </shadow>
          </value>
        </block>
      </category>
      <sep></sep>
      <category name="Mathe" colour="#5b67a5">
        <block type="math_number">
          <field name="NUM">0</field>
        </block>
        <block type="math_arithmetic">
          <field name="OP">ADD</field>
          <value name="A">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
          <value name="B">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
        </block>
        <block type="math_single">
          <field name="OP">ROOT</field>
          <value name="NUM">
            <shadow type="math_number">
              <field name="NUM">9</field>
            </shadow>
          </value>
        </block>
        <block type="math_trig">
          <field name="OP">SIN</field>
          <value name="NUM">
            <shadow type="math_number">
              <field name="NUM">45</field>
            </shadow>
          </value>
        </block>
        <block type="math_constant">
          <field name="CONSTANT">PI</field>
        </block>
        <block type="math_number_property">
          <mutation divisor_input="false"></mutation>
          <field name="PROPERTY">EVEN</field>
          <value name="NUMBER_TO_CHECK">
            <shadow type="math_number">
              <field name="NUM">0</field>
            </shadow>
          </value>
        </block>
        <block type="math_round">
          <field name="OP">ROUND</field>
          <value name="NUM">
            <shadow type="math_number">
              <field name="NUM">3.1</field>
            </shadow>
          </value>
        </block>
        <block type="math_on_list">
          <mutation op="SUM"></mutation>
          <field name="OP">SUM</field>
        </block>
        <block type="math_modulo">
          <value name="DIVIDEND">
            <shadow type="math_number">
              <field name="NUM">64</field>
            </shadow>
          </value>
          <value name="DIVISOR">
            <shadow type="math_number">
              <field name="NUM">10</field>
            </shadow>
          </value>
        </block>
        <block type="math_constrain">
          <value name="VALUE">
            <shadow type="math_number">
              <field name="NUM">50</field>
            </shadow>
          </value>
          <value name="LOW">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
          <value name="HIGH">
            <shadow type="math_number">
              <field name="NUM">100</field>
            </shadow>
          </value>
        </block>
        <block type="math_random_int">
          <value name="FROM">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
          <value name="TO">
            <shadow type="math_number">
              <field name="NUM">100</field>
            </shadow>
          </value>
        </block>
        <block type="math_random_float"></block>
      </category>
    </xml>
  </div>
</template>

<script>
import Blockly from 'blockly';
import scripttasks from '@/modules/scripttasks.js'
import AceEditor from '@/components/AceEditor.vue'
import CTreeView from '@/components/tree/CTreeView.vue'
import CronExprBuilder from '@/components/CronExprBuilder.vue'

export default {
  name: 'ScriptTaskEditor',
  components: {
    AceEditor,
    CronExprBuilder,
    CTreeView
  },
  data() {
    return {
      script: { id: "SkriptNeu", script: "",cron:'',useBlocks: false, catid: 0, input: {}, output: {}},
      inputEdit: {},
      outputEdit: {},
      paramdata: '',
      tabIndex: 1,
    }
  },
  mounted: function() {

    this.$nextTick(function() {
      this.initCustomBlocks();
      this.blockSpace = Blockly.inject('blocklyDiv',{toolbox: document.getElementById('toolbox')});

      var sid = this.$route.params.scriptid;

      if (sid && sid != 'new') {
        var self = this;
        scripttasks.load(this,this.$route.params.scriptid,function(data) {
          self.script          = data;
          self.$refs.cron.cron = data.cron;
          self.$refs.cattree.activateNode({id: data.catid || '0'});
          // rework old entries
          if (data.useBlocks === undefined) data.useBlocks = false;
          if (!data.useBlocks) self.tabIndex = 0;
          self.loadBlocks();
        })
      } else {
        this.tabIndex = 0;
      }

    });

  },
  methods: {
    execScript: function() {
      var pjson = {};
      if (this.paramdata.length > 0) {
        pjson = JSON.parse(this.paramdata);
      }
      if (this.script.useBlocks) {
        this.script.blockScript = Blockly.JavaScript.workspaceToCode(this.blockSpace);
      }
      var data  = JSON.parse(JSON.stringify(this.script));
      data.paramData = pjson;
      console.log(data);
      scripttasks.test(this,data,function(result) {
        console.log(result);
      })
    },
    importBlocks() {
      this.tabIndex = 0;
      console.log('import');
      var curr = this.$refs.editor.getContent();
      if (curr && curr.length > 0 && !confirm('Möchten Sie das aktuelle Skript überschreiben?')) {
        return;
      }
      this.$nextTick(function() {
        var js = Blockly.JavaScript.workspaceToCode(this.blockSpace);
        this.script.script = js;
        this.$refs.editor.setContent(js);
        console.log(js);
      });
    },
    loadBlocks() {
      if (this.script.blocks) {
        var xml = Blockly.Xml.textToDom(this.script.blocks);
        console.log(xml);
        if (xml) {
          Blockly.Xml.domToWorkspace(xml,this.blockSpace);
        }
      }
    },
    editInputParam(item) {
      this.inputEdit = item;
      this.$bvModal.show('inputParam');
    },
    editOutputParam(item) {
      this.outputEdit = item;
      this.$bvModal.show('outputParam');
    },
    addInputParam() {
      this.inputEdit = {};
      this.$bvModal.show('inputParam');
    },
    saveInputParam() {
      this.script.input = this.script.input || {};
      this.script.input[this.inputEdit.name] = this.inputEdit;
      this.$forceUpdate();
    },
    removeInputParam(name) {
      console.log('Delete: ' + name);
      delete this.script.input[name];
      this.$forceUpdate();
    },
    addOutputParam() {
      this.outputEdit = {};
      this.$bvModal.show('outputParam');
    },
    saveOutputParam() {
      this.script.output = this.script.output || {};
      this.script.output[this.outputEdit.name] = this.outputEdit;
      this.$forceUpdate();
    },
    removeOutputParam(name) {
      console.log('Delete: ' + name);
      delete this.script.output[name];
      this.$forceUpdate();
    },
    updateCategory: function(node) {
      if (node)
      this.script.catid = node.id;
    },
    save: function() {
      console.log('savescript')
      this.script.cron = this.$refs.cron.cron;
      this.script.script = this.$refs.editor.getContent();
      this.script.blocks = Blockly.Xml.domToText(Blockly.Xml.workspaceToDom(Blockly.getMainWorkspace()));
      if (this.script.useBlocks)
      this.script.blockScript = Blockly.JavaScript.workspaceToCode(this.blockSpace);

      console.log(JSON.stringify(this.script));
      var self = this;
      scripttasks.save(this,this.script,function() {
        self.$bvToast.toast('Skript gespeichert',{title: 'Skript Tasks',variant: 'success'})
      })
    },
    initCustomBlocks() {
      var sysExec = {
        "type": "sys_exec",
        "message0": "sys.execute %1 workdir %2 args %3",
        "args0": [
          {
            "type": "input_value",
            "name": "command",
            "check": "String",
            "align": "RIGHT"
          },
          {
            "type": "input_value",
            "name": "workDir",
            "check": "String",
            "align": "RIGHT"
          },
          {
            "type": "input_value",
            "name": "args",
            "check": "String",
            "align": "RIGHT"
          }
        ],
        "previousStatement": null,
        "nextStatement": null,
        "colour": 180,
        "tooltip": "Ausführen eines System-Befehls.",
        "helpUrl": ""
      };
      var sysLog = {
        "type": "sys_log",
        "message0": "sys.log %1 type %2",
        "args0": [
          {
            "type": "input_value",
            "name": "msg",
            "check": "String",
            "align": "RIGHT"
          },
          {
            "type": "field_dropdown",
            "name": "type",
            "align": "RIGHT",
            "options": [
              [
                "info",
                "info"
              ],
              [
                "warn",
                "warn"
              ],
              [
                "error",
                "error"
              ]
            ]
          },
        ],
        "previousStatement": null,
        "nextStatement": null,
        "colour": 180,
        "tooltip": "Log im System einer Meldung.",
        "helpUrl": ""
      };
      var sysSleep = {
        "type": "sys_sleep",
        "message0": "sys.sleep %1",
        "args0": [
          {
            "type": "input_value",
            "name": "time",
            "check": "Number",
            "align": "RIGHT"
          },
        ],
        "previousStatement": null,
        "nextStatement": null,
        "colour": 180,
        "tooltip": "Warten für eine gewünschte Zahl an ms.",
        "helpUrl": ""
      };
      var sysPrint = {
        "type": "sys_print",
        "message0": "sys.print %1",
        "args0": [
          {
            "type": "input_value",
            "name": "msg",
            "check": "String",
            "align": "RIGHT"
          },
        ],
        "previousStatement": null,
        "nextStatement": null,
        "colour": 180,
        "tooltip": "Text auf der Konsole (stdout) ausgeben.",
        "helpUrl": ""
      };
      var custLoad = {
        "type": "customer_load",
        "message0": "customer.load %1",
        "args0": [
          {
            "type": "input_value",
            "name": "mapid",
            "check": "String",
            "align": "RIGHT"
          },
        ],
        "output": null,
        "colour": 330,
        "tooltip": "Kundeneintrag laden.",
        "helpUrl": ""
      };
      var custContactLoad = {
        "type": "customer_contact_load",
        "message0": "contact.load %1",
        "args0": [
          {
            "type": "input_value",
            "name": "mapid",
            "check": "String",
            "align": "RIGHT"
          },
        ],
        "output": null,
        "colour": 330,
        "tooltip": "Kunden-Adress eintrag laden.",
        "helpUrl": ""
      }
      var custSearch = {
        "type": "customer_search",
        "message0": "customer.search %1 start %2 count %3",
        "args0": [
          {
            "type": "input_value",
            "name": "search",
            "check": "String",
            "align": "RIGHT"
          },
          {
            "type": "input_value",
            "name": "start",
            "check": "Number",
            "align": "RIGHT"
          },
          {
            "type": "input_value",
            "name": "count",
            "check": "Number",
            "align": "RIGHT"
          },
        ],
        "output": null,
        "colour": 330,
        "tooltip": "Kundeneinträge durchsuchen.",
        "helpUrl": ""
      };
      // email funktionen
      var mailSend = {
        "type": "email_send",
        "message0": "mail.send to %1 cc %2 subject %3 type %4 text %5 files %6",
        "args0": [
          {
            "type": "input_value",
            "name": "receiver",
            "check": "String",
            "align": "RIGHT"
          },
          {
            "type": "input_value",
            "name": "copy",
            "check": "String",
            "align": "RIGHT"
          },
          {
            "type": "input_value",
            "name": "subject",
            "check": "String",
            "align": "RIGHT"
          },
          {
            "type": "field_dropdown",
            "name": "content",
            "options": [
              [
                "Text",
                "text/plain"
              ],
              [
                "HTML",
                "text/html"
              ]
            ],
            "align": "LEFT"
          },
          {
            "type": "input_value",
            "name": "message",
            "check": "String",
            "align": "RIGHT"
          },
          {
            "type": "input_value",
            "name": "files",
            "check": "Array",
            "align": "RIGHT"
          }
        ],
        "previousStatement": null,
        "nextStatement": null,
        "colour": 350,
        "tooltip": "E-Mail senden.",
        "helpUrl": ""
      };
      // article blocks
      var articleLoad = {
        "type": "article_load",
        "message0": "article.load %1",
        "args0": [
          {
            "type": "input_value",
            "name": "mapid",
            "check": "String",
            "align": "RIGHT"
          },
        ],
        "output": null,
        "colour": 90,
        "tooltip": "Artikeleintrag laden.",
        "helpUrl": ""
      }
      var articleSearch = {
        "type": "article_search",
        "message0": "article.search %1 lang %2 filter %3 start %4 count %5",
        "args0": [
          {
            "type": "input_value",
            "name": "search",
            "check": "String",
            "align": "RIGHT"
          },
          {
            "type": "input_value",
            "name": "lang",
            "check": "String",
            "align": "RIGHT"
          },
          {
            "type": "input_value",
            "name": "filter",
            "check": "String",
            "align": "RIGHT"
          },
          {
            "type": "input_value",
            "name": "start",
            "check": "Number",
            "align": "RIGHT"
          },
          {
            "type": "input_value",
            "name": "count",
            "check": "Number",
            "align": "RIGHT"
          },
        ],
        "output": null,
        "colour": 90,
        "tooltip": "Artikeleinträge durchsuchen.",
        "helpUrl": ""
      };
      // http blocks
      var httpRequest = {
        "type": "web_request",
        "message0": "web.request url %1 method %2 header %3 body %4",
        "args0": [
          {
            "type": "input_value",
            "name": "url",
            "check": "String",
            "align": "RIGHT"
          },
          {
            "type": "field_dropdown",
            "name": "method",
            "options": [
              [
                "GET",
                "get"
              ],
              [
                "POST",
                "post"
              ],
              [
                "PUT",
                "put"
              ]
            ],
            "align": "LEFT"
          },
          {
            "type": "input_value",
            "name": "header",
            "align": "RIGHT"
          },
          {
            "type": "input_value",
            "name": "body",
            "check": "String",
            "align": "RIGHT"
          },
        ],
        "output": null,
        "colour": 350,
        "tooltip": "Artikeleintrag laden.",
        "helpUrl": ""
      }



      // register json blocks
      Blockly.Blocks['sys_exec'] = {
        init: function() {
          this.jsonInit(sysExec);
        }
      };
      Blockly.Blocks['sys_log'] = {
        init: function() {
          this.jsonInit(sysLog);
        }
      };
      Blockly.Blocks['sys_sleep'] = {
        init: function() {
          this.jsonInit(sysSleep);
        }
      };
      Blockly.Blocks['sys_print'] = {
        init: function() {
          this.jsonInit(sysPrint);
        }
      };
      Blockly.Blocks['customer_load'] = {
        init: function() {
          this.jsonInit(custLoad);
        }
      };
      Blockly.Blocks['customer_contact_load'] = {
        init: function() {
          this.jsonInit(custContactLoad);
        }
      };
      Blockly.Blocks['customer_search'] = {
        init: function() {
          this.jsonInit(custSearch);
        }
      };
      Blockly.Blocks['email_send'] = {
        init: function() {
          this.jsonInit(mailSend);
        }
      };
      Blockly.Blocks['article_load'] = {
        init: function() {
          this.jsonInit(articleLoad);
        }
      };
      Blockly.Blocks['article_search'] = {
        init: function() {
          this.jsonInit(articleSearch);
        }
      };
      Blockly.Blocks['web_request'] = {
        init: function() {
          this.jsonInit(httpRequest);
        }
      };


      // create javascript bridges
      Blockly.JavaScript['sys_exec'] = function(block) {
        var value_cmd  = Blockly.JavaScript.valueToCode(block, 'command', Blockly.JavaScript.ORDER_ATOMIC);
        var value_wdir = Blockly.JavaScript.valueToCode(block, 'workDir', Blockly.JavaScript.ORDER_ATOMIC);
        var value_args = Blockly.JavaScript.valueToCode(block, 'args', Blockly.JavaScript.ORDER_ATOMIC);

        var code = 'sys.exec(' + value_cmd + ',' + value_wdir + ',' + value_args + ');\n';
        return code;
      };

      Blockly.JavaScript['sys_log'] = function(block) {
        var value_msg  = Blockly.JavaScript.valueToCode(block, 'msg', Blockly.JavaScript.ORDER_ATOMIC);
        var value_type = block.getFieldValue('type');

        var code;
        if (value_type == 'error')
          code = 'sys.logError(' + value_msg + ');\n';
        else if (value_type == 'warn')
          code = 'sys.logWarning(' + value_msg + ');\n';
        else
          code = 'sys.logInfo(' + value_msg + ');\n';

        return code;
      };

      Blockly.JavaScript['sys_sleep'] = function(block) {
        var value_msg  = Blockly.JavaScript.valueToCode(block, 'time', Blockly.JavaScript.ORDER_ATOMIC);

        var code = 'sys.sleep(' + value_msg + ');\n';
        return code;
      };

      Blockly.JavaScript['sys_print'] = function(block) {
        var value_msg  = Blockly.JavaScript.valueToCode(block, 'msg', Blockly.JavaScript.ORDER_ATOMIC);

        var code = 'sys.print(' + value_msg + ');\n';
        return code;
      };

      Blockly.JavaScript['customer_load'] = function(block) {
        var value_msg  = Blockly.JavaScript.valueToCode(block, 'mapid', Blockly.JavaScript.ORDER_ATOMIC);

        var code = 'customerif.getCustomer(' + value_msg + ');\n';
        return code;
      };

      Blockly.JavaScript['customer_contact_load'] = function(block) {
        var value_msg  = Blockly.JavaScript.valueToCode(block, 'mapid', Blockly.JavaScript.ORDER_ATOMIC);

        var code = 'customerif.getContact(' + value_msg + ');\n';
        return code;
      };

      Blockly.JavaScript['customer_search'] = function(block) {
        var value_search = Blockly.JavaScript.valueToCode(block, 'search', Blockly.JavaScript.ORDER_ATOMIC);
        var value_start  = Blockly.JavaScript.valueToCode(block, 'start', Blockly.JavaScript.ORDER_ATOMIC);
        var value_count  = Blockly.JavaScript.valueToCode(block, 'count', Blockly.JavaScript.ORDER_ATOMIC);

        var code = 'customerif.search(' + value_search + ',' + value_start + ',' + value_count + ');\n';
        return code;
      };

      Blockly.JavaScript['email_send'] = function(block) {
        var value_rec     = Blockly.JavaScript.valueToCode(block, 'receiver', Blockly.JavaScript.ORDER_ATOMIC);
        var value_copy    = Blockly.JavaScript.valueToCode(block, 'copy', Blockly.JavaScript.ORDER_ATOMIC);
        var value_subject = Blockly.JavaScript.valueToCode(block, 'subject', Blockly.JavaScript.ORDER_ATOMIC);
        var value_msg     = Blockly.JavaScript.valueToCode(block, 'message', Blockly.JavaScript.ORDER_ATOMIC);
        var value_type    = block.getFieldValue('content');
        var value_files   = Blockly.JavaScript.valueToCode(block, 'files', Blockly.JavaScript.ORDER_ATOMIC);

        if (!value_copy) value_copy = "''";

        console.log(value_files);

        var code;
        if (value_files && value_files.length > 0) {
          code = 'mail.send(' + value_rec + ',' + value_copy + ',' + value_subject + ',' + value_msg + ',"' + value_type + '");\n';
        } else {
          code = 'mail.send(' + value_rec + ',' + value_copy + ',' + value_subject + ',' + value_msg + ',"' + value_type + '",' + value_files + ');\n';
        }
        return code;
      };

      Blockly.JavaScript['article_load'] = function(block) {
        var value_msg  = Blockly.JavaScript.valueToCode(block, 'mapid', Blockly.JavaScript.ORDER_ATOMIC);

        var code = 'articleif.getArticle(' + value_msg + ');\n';
        return code;
      };

      Blockly.JavaScript['article_search'] = function(block) {
        var value_search = Blockly.JavaScript.valueToCode(block, 'search', Blockly.JavaScript.ORDER_ATOMIC);
        var value_lang   = Blockly.JavaScript.valueToCode(block, 'lang', Blockly.JavaScript.ORDER_ATOMIC);
        var value_filter = Blockly.JavaScript.valueToCode(block, 'filter', Blockly.JavaScript.ORDER_ATOMIC);
        var value_start  = Blockly.JavaScript.valueToCode(block, 'start', Blockly.JavaScript.ORDER_ATOMIC);
        var value_count  = Blockly.JavaScript.valueToCode(block, 'count', Blockly.JavaScript.ORDER_ATOMIC);

        var code = 'articleif.search(' + value_search + ',' + value_lang + ',' + value_filter + ',' + value_start + ',' + value_count + ');\n';

        return code;
      };

      Blockly.JavaScript['web_request'] = function(block) {
        var value_url     = Blockly.JavaScript.valueToCode(block, 'receiver', Blockly.JavaScript.ORDER_ATOMIC);
        var value_method  = block.getFieldValue('content');

        var code = 'web.' + value_method + '(' + value_url + ',{});';
        return code;
      };


    }
  },
}
</script>
